import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import ImmutableRenderMixin from 'react-immutable-render-mixin';
import ImmutablePropTypes from 'react-immutable-proptypes';
import moment from 'moment';
import {List} from 'immutable';
import classnames from 'classnames';
import {Request, GET, POST, DELETE} from 'requests';
import {default as RequestsMixin, IS_DONE, HAS_FAILED} from 'requests/RequestsMixin';
import {ResourcesMatching, Done} from 'requests/components';
import {published} from 'actions';
import {needsPublishing} from '../utils/kit';

const HUNG_PUBLICATION_TIMEOUT = 5;   // in minutes
const HUNG_PUBLICATION_INTERVAL = 5;  // in seconds

function mostRecentPublication(publications) {
  let value = null;

  if (publications.size > 0) {
    value = publications
      .sortBy(publication => publication.startedAt.unix())
      .reverse()
      .first();
  }

  return value;
}

const mapStateToProps = (state, ownProps) => {
  return {
    requests: state.requests,
    kitMutations: state.kitMutations,
  };
};

const PublishButton = createReactClass({
  propTypes: {
    dispatch: PropTypes.func.isRequired,
    requests: PropTypes.object,
    kitMutations: ImmutablePropTypes.map.isRequired,
    kit: ImmutablePropTypes.record.isRequired,
    onPublishing: PropTypes.func,
    onPublished: PropTypes.func,
    onFirstTimePublished: PropTypes.func,
  },

  mixins: [RequestsMixin, ImmutableRenderMixin],

  getDefaultProps() {
    return {
      onPublished: () => {},
      onPublishing: () => {},
      onFirstTimePublished: () => {},
    };
  },

  getInitialState() {
    return {
      buttonDisabled: true,
      lastStatus: null,
      lastPublishFailed: false,
      hasNeverBeenPublished: false,
      hungPublicationWatcher: moment(),
    };
  },

  componentWillMount() {
    this.setRequest({
      kit: new Request({
        method: GET,
        url: ['api', 'kits', this.props.kit.token],
      }),
    });

    this.setRequest({
      publications: new Request({
        method: GET,
        url: ['api', 'kits', this.props.kit.token, 'publications'],
      }),
    });

    this.setRequest({
      workingSetIcons: new Request({
        method: GET,
        url: ['api', 'kits', this.props.kit.token, 'working-set-icons'],
      }),
    });

    this.setRequest({
      workingSetTypefaces: new Request({
        method: GET,
        url: ['api', 'kits', this.props.kit.token, 'working-set-typefaces'],
      }),
    });

    this.setRequest({
      workingSetImages: new Request({
        method: GET,
        url: ['api', 'kits', this.props.kit.token, 'working-set-images'],
      }),
    });

    this.scheduleHungWatcher();
  },

  componentWillUnmount() {
    clearTimeout(this.state.hungPublicationWatcher);
  },

  scheduleHungWatcher() {
    this.setState({
      hungPublicationWatcher: setTimeout(() => {
        this.scheduleHungWatcher();
      }, HUNG_PUBLICATION_INTERVAL * 1000),
    });
  },

  componentWillReceiveProps(nextProps) {
    let {lastStatus, hasNeverBeenPublished} = this.state;
    const publication = this.mostRecentPublication(nextProps);
    const rm = this.resourceManager(nextProps);
    const publicationsLoaded = rm.requests.isDone(this.requests.publications);
    const finishedPublications = rm.type(this.requests.publications, 'publications')
      .all()
      .filter(p => p.status === 'finished');

    if (publication) {
      if (lastStatus === 'processing' && publication.status === 'finished') {
        this.props.dispatch(published(this.props.kit.token));

        this.props.onPublished();

        this.setState({buttonDisabled: false});

        if (this.state.hasNeverBeenPublished) {
          this.props.onFirstTimePublished();

          hasNeverBeenPublished = false;
        }
      }

      if (lastStatus === 'processing' && publication.status === 'errored') {
        this.setState({lastPublishFailed: true});
      }

      lastStatus = publication.status;
    }

    hasNeverBeenPublished = publicationsLoaded && finishedPublications.isEmpty();

    this.setState({
      lastStatus,
      hasNeverBeenPublished,
    });
  },

  transitions(register) {
    register({
      request: this.requests.publications,
      to: IS_DONE,
      call(rm) {
        const publications = rm.type(this.requests.publications, 'publications').all();
        const publication = mostRecentPublication(publications);

        if (publication) {
          this.setState({
            buttonDisabled: (publication.status === 'processing'),
            lastPublishFailed: (publication.status === 'errored'),
          });
        } else {
          this.setState({
            buttonDisabled: false,
          });
        }
      },
    });

    register({
      request: this.requests.publishKit,
      to: IS_DONE,
      call(rm) {
        this.props.onPublishing();
      },
    });

    register({
      request: this.requests.publishKit,
      to: HAS_FAILED,
      call(rm) {
        this.setState({
          lastPublishFailed: true,
        });
      },
    });

    register({
      request: this.requests.deletePublication,
      to: IS_DONE,
      call(rm) {
        this.handleClick();
      },
    });
  },

  resources(props = null) {
    const {
      kit: kitRequest,
      publications: publicationsRequest,
      workingSetIcons: workingSetIconsRequest,
      workingSetTypefaces: workingSetTypefacesRequest,
      workingSetImages: workingSetImagesRequest,
    } = this.requests;
    const rm = this.resourceManager(props || this.props);
    const workingSet = rm.type(kitRequest, 'working-sets').get();
    const publications = rm.type(publicationsRequest, 'publications').all();
    const workingSetIcons = rm.type(workingSetIconsRequest, 'working-set-icons').all();
    const workingSetTypefaces = rm.type(workingSetTypefacesRequest, 'working-set-typefaces').all();
    const workingSetImages = rm.type(workingSetImagesRequest, 'working-set-images').all();

    return {publications, workingSet, workingSetIcons, workingSetTypefaces, workingSetImages};
  },

  handleClick(event) {
    if (event) {
      event.preventDefault();
    }

    this.setState({
      buttonDisabled: true,
    }, () => {
      this.publish();
    });
  },

  handleTryPublishingAgain(event) {
    this.setState({
      lastPublishFailed: false,
    });

    this.handleClick(event);
  },

  handleTryPublishingAfterHung(event) {
    const publication = this.mostRecentPublication();

    this.setRequest({
      deletePublication: new Request({
        method: DELETE,
        url: ['api', 'kits', this.props.kit.token, 'publications', publication.id],
        record: publication,
      }),
    });
  },

  handleGetSupport(event) {
    this.setState({
      lastPublishFailed: false,
      buttonDisabled: false,
    });
  },

  mostRecentPublication(props = null) {
    const {publications} = this.resources(props);

    return mostRecentPublication(publications);
  },

  getButtonAndTiming() {
    const {buttonDisabled} = this.state;
    const publication = this.mostRecentPublication();
    let button = 'Publish';
    let timing = '';

    if (publication) {
      if (publication.status !== 'finished') {
        button = this.getButtonSpinning();
      }

      if (publication.startedAt.isValid()) {
        timing = `Started publishing ${publication.startedAt.fromNow()}`;
      }

      if (publication.erroredAt.isValid()) {
        timing = `Failed to publish ${publication.erroredAt.fromNow()}`;
      }

      if (publication.finishedAt.isValid()) {
        timing = `Published ${publication.finishedAt.fromNow()}`;
      }
    }

    if (buttonDisabled) {
      button = this.getButtonSpinning();
    }

    return [button, timing];
  },

  getButtonSpinning() {
    return <span className="animated infinite pulseOpacity"><i className="ficon ficon-spinner-third ficon-spin m-xs-r-xs"></i> Publishing&hellip;</span>;
  },

  publish() {
    const {kit} = this.props;
    const {workingSet} = this.resources();

    this.setRequest({
      publishKit: new Request({
        url: ['api', 'kits', kit.token, 'publications'],
        method: POST,
        record: workingSet,
      }),
    });
  },

  workingSetEmpty() {
    const {
      workingSetIcons: workingSetIconsRequest,
      workingSetTypefaces: workingSetTypefacesRequest,
      workingSetImages: workingSetImagesRequest,
    } = this.requests;
    const rm = this.resourceManager();
    const workingSetIcons = rm.type(workingSetIconsRequest, 'working-set-icons').all();
    const workingSetTypefaces = rm.type(workingSetTypefacesRequest, 'working-set-typefaces').all();
    const workingSetImages = rm.type(workingSetImagesRequest, 'working-set-images').all();

    return workingSetIcons.size === 0 && workingSetTypefaces.size === 0 && workingSetImages.size === 0;
  },

  updatesArePending() {
    const {
      workingSetIcons,
      workingSetTypefaces,
      workingSetImages,
    } = this.resources();

    const all = List()
      .concat(workingSetIcons)
      .concat(workingSetTypefaces)
      .concat(workingSetImages);

    const publication = this.mostRecentPublication();
    const lastWorkingSetChange = Math.max(...all.map(i => i.updatedAt.unix()));

    let value = false;

    if (publication) {
      value = publication.finishedAt.unix() < lastWorkingSetChange;
    }

    return needsPublishing(this.props.kitMutations, this.props.kit.token) || value;
  },

  appearsHung() {
    const publication = this.mostRecentPublication();
    let value = false;

    if (publication && publication.status === 'processing') {
      const publicationStartedAt = publication.startedAt;
      const now = moment();

      value = moment.duration(now.diff(publicationStartedAt)).asMinutes() > HUNG_PUBLICATION_TIMEOUT;
    }

    return value;
  },

  renderPublishButton() {
    const {buttonDisabled} = this.state;
    const workingSetEmpty = this.workingSetEmpty();
    const hasNoPublications = !this.mostRecentPublication();
    const buttonType = ((this.updatesArePending() || hasNoPublications) && !buttonDisabled) ? 'btn-primary' : 'btn-secondary';
    const buttonClassName = classnames('btn', 'btn-lg', 'm-xs-l-md', buttonType);

    const [button, timing] = this.getButtonAndTiming();

    return (
      <div>
        {timing}

        <button onClick={this.handleClick} className={buttonClassName} disabled={buttonDisabled || workingSetEmpty}>
          {button}
        </button>
      </div>
    );
  },

  renderPublishFailed() {
    return (
      <div>
        <i className="ficon ficon-exclamation-circle"></i> We failed to publish your kit. You can <a href="#" onClick={this.handleTryPublishingAgain}>publish again</a> or

        <button onClick={this.handleGetSupport} className="btn btn-lg m-xs-l-md btn-secondary">Get support</button>
      </div>
    );
  },

  renderPublishHung() {
    return (
      <div>
        <i className="ficon ficon-exclamation-circle"></i> This is taking too long, let&apos;s start over. <a href="#" onClick={this.handleTryPublishingAfterHung}>Publish again</a> or

        <button onClick={this.handleGetSupport} className="btn btn-lg m-xs-l-md btn-secondary">Get support</button>
      </div>
    );
  },

  renderMain() {
    let value = (this.state.lastPublishFailed) ? this.renderPublishFailed() : this.renderPublishButton();

    if (this.appearsHung()) {
      value = this.renderPublishHung();
    }

    return value;
  },

  render() {
    const requests = [
      this.requests.kit,
      this.requests.publications,
    ];

    return (
      <ResourcesMatching manager={this.resourceManager()}>
        <Done all={requests} render={this.renderMain} />
      </ResourcesMatching>
    );
  },
});

export default connect(mapStateToProps)(PublishButton);



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/components/PublishButton.js